<template>
  <v-row class="pa-2 fill-height" justify="space-between" align="stretch">
    <v-col cols="12" class="pb-0">
      <v-row justify="space-between" align="stretch" no-gutters class="px-2">
        <v-col cols="12"> <h3 class="mb-2">Orders Timeline</h3> </v-col>
      </v-row>
      <v-row justify="space-between" align="stretch" no-gutters class="px-2">
        <v-col cols="6" md="4">
          <v-dialog ref="dialog" v-model="fromDialog" persistent width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                v-model="fromText"
                label="From Date"
                prepend-icon="mdi-calendar"
                readonly
              ></v-text-field>
            </template>

            <v-date-picker
              v-model="fromDate"
              no-title
              :max="fromMaxAllowed"
              v-on:change="(fromDialog = false), getCount()"
            >
              <v-spacer></v-spacer>
              <v-btn text color="blue darken-2" @click="fromDialog = false"
                >Cancel</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-col cols="6" md="4">
          <v-dialog ref="dialog" v-model="toDialog" persistent width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                v-model="toText"
                label="To Date"
                prepend-icon="mdi-calendar"
                readonly
              ></v-text-field>
            </template>

            <v-date-picker
              v-model="toDate"
              no-title
              v-on:change="(toDialog = false), getCount()"
              :max="toMaxAllowed"
            >
              <v-spacer></v-spacer>
              <v-btn text color="blue darken-2" @click="toDialog = false"
                >Cancel</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <apexchart
        type="area"
        height="350"
        :options="chartOptions"
        :series="series"
        ref="chart1"
      ></apexchart>
    </v-col>
  </v-row>
</template>

<script>
import axios from "@/axios";
import moment from "moment";

export default {
  data() {
    return {
    series:[],
    chartOptions: {
      chart: {
        height: 350,
        type: "area",
      },
      stroke: {
        width: [0, 4],
      },
      dataLabels:{
        enabled:false
      },
      xaxis: {
         type: 'datetime',
      },
      noData:{
        text:'Loading...'
      },

    },

    fromDate: moment(this.getDate(28)).format("YYYY-MM-DD"),
    toDate: moment(this.getDate(0)).format("YYYY-MM-DD"),
    fromDialog: false,
    toDialog: false,
    }
  },

  activated() {
    this.getCount();
  },

  computed: {
    fromText() {
      return this.fromDate ? moment(this.fromDate).format("Do MMM  YY") : "";
    },

    toText() {
      return this.toDate ? moment(this.toDate).format("Do MMM  YY") : "";
    },

    toMaxAllowed(){
      return moment().format("YYYY-MM-DD");
    },

    fromMaxAllowed() {
      return this.toDate;
    }
  },

  methods: {
    getDate(daysPast = 0) {
      let today = new Date();
      today.setDate(today.getDate() - daysPast);

      return today;
    },
    async getCount() {
      this.series =[]
      this.$refs.chart1.updateOptions({
        labels: [], 
      })
      
      
      let stringPayload = JSON.stringify({
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        startDate: this.fromDate,
        endDate : this.toDate
      });

      const params = new URLSearchParams();

      params.append("params", stringPayload);
      await axios.post("order/get-orders-stats", params).then((response) => {
        if (response.data.success) {
          console.log("-- Chart Response");
          console.log(response);

          console.log(this.chartOptions);

          let order = response.data.orders;
          order = Object.fromEntries(Object.entries(order).sort());
          let chartLabels = Object.keys(order);

          console.log("-- Checking Data");
          console.log(chartLabels);
          let orderSeries = []
          let totalSeries = []
          for (const date of chartLabels) {
            console.log("-- Checking Push");
            console.log(date);
            console.log(response.data.orders[date]["orders"]);
            console.log(response.data.orders[date]["total"]);
            orderSeries.push(response.data.orders[date]["orders"]);
            totalSeries.push(response.data.orders[date]["total"]);
          }
          this.$refs.chart1.updateOptions(
            {
              dataLabels: {
                enabled: true,
                enabledOnSeries: [1],
              },
              labels: chartLabels,
              yaxis: [
                {
                  title: {
                    text: "Number of Orders",
                  },
                  labels: {
                    formatter: function (value) {
                      return value.toFixed(0);
                    },
                  },
                },
                {
                  opposite: true,
                  title: {
                    text: "Orders Value £",
                  },
                  labels: {
                    formatter: function (value) {
                      return "£" + value.toFixed(2);
                    },
                  },
                },
              ],
            }
          )
          this.$refs.chart1.updateSeries(
            [
              {
                name: "Number of Orders",
                type: "column",
                data: orderSeries,
              },
              {
                name: "Orders Value",
                type: "area",
                data: totalSeries,
              }
            ],true)
        } else {
          this.$emit('timeline-hide');
        }
      });
    },
  },
};
</script>

<style lang="sass" scoped>
</style>